import { InfoIcon } from 'components/common/Icons/Icons';

import styles from './MessageForIntermediary.module.scss';

const MessageForIntermediary = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.textContainer}>
        <div className={styles.headerLabel}>Welcome To Your HFS Contractor Portal</div>
        <div className={styles.textWithIcon}>
          <InfoIcon />
          <div className={styles.infoText}>
            If any action is needed from you it will appear in the “action needed“ column.
          </div>
        </div>
        <div className={styles.textWithIcon}>
          <InfoIcon />
          <div className={styles.infoText}>
            Please reach out to your dedicated HFS account manager with any questions or concerns. You can find
            information about your manager on the top right corner.
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageForIntermediary;
